/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CurrencyEnumDto } from './currencyEnumDto';


export interface RateDto { 
    rateId?: string;
    merchantName?: string;
    merchantId?: string;
    rateName?: string;
    currency: CurrencyEnumDto;
    createdOn: Date;
    effectiveDate: Date;
    terminationDate: Date;
    isDedicated: boolean;
    isDeleted: boolean;
    isExpired: boolean;
    isExtended: boolean;
}
